import { render, staticRenderFns } from "./DfmDemo.vue?vue&type=template&id=c6f515c6&"
import script from "./DfmDemo.vue?vue&type=script&lang=js&"
export * from "./DfmDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports